import { useMemo, useState } from 'react';

import { ReactComponent as ChevronIcon } from 'assets/icons/chevron4.svg';

import TooltipNew from '../TooltipNew/TooltipNew';
import style from './MenuItemDropdown.module.css';

interface Props {
  trigger: any;
  children: any;
  closeOnClick?: boolean;
  type?: 'light' | 'dark';
  tooltip?: string;
}

const MenuItemDropdown = ({ trigger, children, closeOnClick, type, tooltip }: Props) => {
  const [open, setOpen] = useState(false);
  const isLightTheme = useMemo(() => type && type === 'light', []);
  return (
    <div className={`${style.container} dropdown-menu`}>
      <TooltipNew tooltip={tooltip}>
        <div
          onClick={() => setOpen(val => !val)}
          className={`${style.trigger} ${open && style.open} ${isLightTheme && style.light}`}
        >
          {trigger}
          <ChevronIcon className={style.chevron} />
        </div>
      </TooltipNew>
      <div
        className={`${style.content} ${!open && style.hidden} ${isLightTheme && style.light}`}
        onClick={() => {
          if (closeOnClick) {
            setOpen(false);
          }
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MenuItemDropdown;
